import PageTemplate from '../templates/page'

export default PageTemplate
